export default "__VITE_ASSET__DIMnK66q__"